import { Icon } from "@clarkinc/zest-design-system/ui";
import React from "react";
import Popover from "~/common/Popover";

const RecommendationCarouselPopover = () => {
  return (
    <Popover
      triggerElement={(ref: React.RefObject<HTMLAnchorElement>) => (
        <a className="more-info pl-1 leading-[0px]" href="#psfy" ref={ref}>
          <Icon
            theme="wss"
            className="fill-current align-top"
            name="ri-question-fill"
            size="xsmall"
          />
        </a>
      )}
      options={{
        placement: "right",
        animation: "none",
      }}
    >
      <p>
        Suggested products are similar or related to the item you are viewing
        and are not necessarily a direct replacement or compatible item.
      </p>
    </Popover>
  );
};

export default React.memo(RecommendationCarouselPopover);
